import { RouteConfig } from 'vue-router'

const route: RouteConfig[] = [
  {
    path: '/lessons/:sessionId/class',
    component: () => import('pages/Session/Index.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/lessons/:sessionId/preview',
    component: () => import('pages/Session/Index.vue'),
    meta: { requiresAuth: true }
  }
]

export default route
